import { Gauge } from "@antv/g2plot";

export const aggregatorMap = {
  sum: "求和",
  avg: "平均值",
  // 'count': '计数',
  min: "最小值",
  max: "最大值",
  // 'distinct-count': '去重计数'
};

export const tableTypeZnMap = {
  0: "贴源表",
  1: "标准表",
  2: "维度",
  3: "标准代码",
  4: "事实",
};

// 申请使用用途
export const applyUseTypeMap = {
  0: "应用系统建设",
  1: "统计分析",
  2: "科研",
  3: "其他",
};

export const useTypesMap = {
  0: "ETL",
  1: "EXCEL",
  2: "API",
};

// 设置面板标签页类型枚举
export const TAB_TYPES = {
  FIELD: "field",
  STYLE: "style",
  ADVANCED: "advanced",
};

export const chartSeriesColors = [
  "#5B8FF9",
  "#61DDAA",
  "#65789B",
  "#F6BD16",
  "#7262FD",
  "#78D3F8",
  "#9661BC",
  "#F6903D",
  "#008685",
  "#F08BB4",
  "#BDD2FD",
  "#BDEFDB",
  "#C2C8D5",
  "#FBE5A2",
  "#D3CEFD",
  "#B6E3F5",
  "#D3C6EA",
  "#FFD8B8",
  "#AAD8D8",
  "#FFD6E7",
];

export const customKey = "w_";

export const lineTypeMap = {
  curve: "curve",
  line: "line",
};

export const lineStyleMap = {
  sty1: "sty1",
  sty2: "sty2",
  sty3: "sty3",
};

export const widgetTypeMap = {
  Table: "Table",
  Column: "Column",
  Pie: "Pie",
  Line: "Line",
  IndicatorCard: "Indicator",
  Gauge: "Gauge",
};

export const widgetConfig = {
  [widgetTypeMap.Table]: { name: "交叉表" },
  [widgetTypeMap.Column]: { name: "柱图" },
  [widgetTypeMap.Pie]: { name: "饼图" },
  [widgetTypeMap.Line]: { name: "折线图" },
  [widgetTypeMap.IndicatorCard]: { name: "指标卡" },
  [widgetTypeMap.Gauge]: { name: "仪表盘" },
};

export const emptyValueMap = {
  skip: 0,
  zero: 1,
  disconnect: 2,
};

export const AuditStatusMap = {
  APPLY: 1,
  AUDITING: 2,
  UNAPPLY: 3,
};

export const AuditStatusConfMap = {
  [AuditStatusMap.APPLY]: {
    text: "可用",
    color: "#67C23A",
    bgColor: "#E8FFEA",
  },
  [AuditStatusMap.AUDITING]: {
    text: "不可用",
    color: "#86909C",
    bgColor: "#F7F8FA",
  },
  [AuditStatusMap.UNAPPLY]: {
    text: "不可用",
    color: "#86909C",
    bgColor: "#F7F8FA",
  },
};

export const UseTypeMap = {
  query: "1",
};